const EquipoStore = {
    data: {
      optix: null,
      westnet: [
        {
          num_router: "",
          num_cliente: 0,
          num_ticket:"",
          asignado: "",
          fecha_asignacion: 0,
          fecha_instalacion: 0,
          metros_drop:"",
          conectores:"",
          estado:""

        }
      ],
      bitway: [
        {
        
          num_router: "",
          num_cliente: 0,
          num_ticket:"",
          asignado: "",
          fecha_asignacion: 0,
          fecha_instalacion: 0,
          metros_drop:"",
          conectores:"",
          estado:"Libre"

        }
      ],
      usuarios: [
        {
          id:"",
          nombre:"",
          email:"",
          password:"",
          rol:"",
          empresa:""
         

        },
        
        
      ],
      tecnicos: [
        {
          id:"",
          nombre:"",
          empresa:"",
          instalaciones:"",
          cambio_tecnologia:"",
          servicio_tecnico:"",
          total_mes:"",

        }
      ],
      totales: [
        {
          id:"",
          nombre:"",
          id_tecnico:"",
          ene23:"",
          feb23:"",
          mar23:"",
          abr23:"",
          may23:"",
          jun23:"",
          jul23:"",
          ago23:"",
          sep23:"",
          oct23:"",
          nov23:"",
          dic23:"",

        }
      ],
      userlogged:"",
      userAuth:[],
      auth:false,
      userType:"",
      optixList:[],
      westnetList:[],
      bitwayList:[],
      usuariosList:[],
      usuariosObject:[],
      tecnicosList:[],
      totalesList:[],

    },
    methods: {
      addnewdataOptix(data) {              
        EquipoStore.data.optix= data
      },
      addnewdataWestnet(propiedad, data) {              
        EquipoStore.data.westnet[0][propiedad] = data
      },
      addnewdataBitway(propiedad, data) {              
        EquipoStore.data.bitway[0][propiedad] = data
      },
      addnewdataTecnicos(propiedad, data) {              
        EquipoStore.data.tecnicos[0][propiedad] = data
      },
      addnewdataTotales(propiedad, data) {              
        EquipoStore.data.totales[0][propiedad] = data
      },

      deleteFavorite(name) {
        EquipoStore.data.equipo.splice(name);
      },
      addnewUser(dato,user) {
        let propiedad= dato 
        let newdata = user
        EquipoStore.data.usuarios[0][propiedad] = newdata
      },
    }
  };
  
  export default EquipoStore;